import React, { useState, useRef } from "react";
import { db } from "../../firebase-config";
import { collection, getDocs, orderBy, query, limit } from "firebase/firestore";
import styles from "./sherlock.module.css";
import DefaultButton from "../../Components/forms/DefaultButton"
import DefaultSelect from "../../Components/DefaultSelect/DefaultSelect";
import Modal from "../../Components/Modal/Modal";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { formatDate } from "../../utils/standaloneUtils";
import LoadingSpinner from "../../Components/Loading/Loading";

const Sherlock = () => {
  const initialData = [
    {
      url: "Não há dados para serem exibidos",
    },
  ];

  const [show, setShow] = useState(false);
  const tableRef = useRef(null);
  const [allData, setAllData] = React.useState(initialData);
  const [filteredData, setFilterdData] = React.useState(initialData);
  const [variable, setVariable] = React.useState(['Não há dados para serem exibidos']);
  const [isLoading, setIsLoading] = useState(false);
  const [tags, setTags] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [newTag, setNewTag] = useState([]);
  const [totalResultado, setTotalResultado] = useState([])
  const [clickAction, setClickAction] = useState('getCollection');
  const [categorias, setCategorias] = useState(true)

  /* CONFIGURAÇÃO DE TAGS */
  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleInputKeyDown = (event) => {
    if (event.key === 'Enter' && inputValue.trim() !== '') {
      const tag = inputValue.trim();

      setNewTag([...tags, tag]);
      setTags([...tags, tag]);
      setInputValue('');
    }
  };

  const handleTagRemove = (tagToRemove) => {
    const updatedTags = tags.filter(tag => tag !== tagToRemove);
    // setTags(updatedTags);
    setTags([]);
    setFilterdData(initialData)
    setTotalResultado([])
  };

  var selectedItems = []
  var selectedItemsStatus = []
  var tempSelectedItemsStatus = []


  async function getCollection() {
    let tipoBusca = document.querySelectorAll('.selectBusca')[0].value
    let categoriaPagina = document.querySelectorAll('.selectBusca')[1].value
    let verificaIndexedFreestyle = (await window.indexedDB.databases()).map(db => db.name).includes('sherlockInfosFreestyle');
    let verificaIndexedBlog = (await window.indexedDB.databases()).map(db => db.name).includes('sherlockInfosBlog');
    let verificaIndexedCMS = (await window.indexedDB.databases()).map(db => db.name).includes('sherlockInfosCMS');

    /* GET DAS INFORMAÇÕES NO INDEXEDB + RENDERIZAÇÃO */
    if (verificaIndexedFreestyle == true && categoriaPagina == 'freestyle') {
      let requestFreestyle = indexedDB.open('sherlockInfosFreestyle');

      requestFreestyle.onsuccess = function (event) {
        setIsLoading(true);

        const db = event.target.result;
        const transaction = db.transaction("freestyle", "readwrite");
        const objectStore = transaction.objectStore("freestyle");
        const getAllRequest = objectStore.getAll();

        let results = []
        let category = "freestyle"

        getAllRequest.onsuccess = function (event) {
          const records = event.target.result;

          if (tipoBusca === 'contem') {
            newTag.forEach((tag) => {
              records.forEach((obj) => {
                if (obj.body.includes(tag)) {
                  results.push({ url: obj.url, categoria: category, tag: tag })
                }
              });
            });
            setFilterdData(results);
            setTotalResultado(results.length)
          } else if (tipoBusca == 'terminaCom') {
            function contemPalavrasQueTerminamComTermo(texto, termo) {
              const palavras = texto.split(/\s+/);
              return palavras.some(palavra => palavra.endsWith(termo));
            }

            let results = []

            newTag.forEach((tag) => {
              records.forEach((obj) => {
                contemPalavrasQueTerminamComTermo(obj.body, tag)
                if (contemPalavrasQueTerminamComTermo(obj.body, tag) == true) {
                  results.push({ url: obj.url, categoria: category, tag: tag })
                }
              });
            });
            setFilterdData(results);
            setTotalResultado(results.length)
          } else if (tipoBusca == 'comecaCom') {
            function contemPalavrasQueComecamComTermo(texto, termo) {
              const palavras = texto.split(/\s+/);
              return palavras.some(palavra => palavra.startsWith(termo));
            }

            let results = []

            newTag.forEach((tag) => {
              records.forEach((obj) => {
                contemPalavrasQueComecamComTermo(obj.body, tag)
                if (contemPalavrasQueComecamComTermo(obj.body, tag) == true) {
                  results.push({ url: obj.url, categoria: category, tag: tag })
                }
              });
            });
            setFilterdData(results);
            setTotalResultado(results.length)
          } else {

            function contemPalavrasQueTerminamComTermo(texto, termo) {
              const palavras = texto.split(/\s+/);
              return palavras.some(palavra => palavra.endsWith(termo));
            }

            function contemPalavrasQueComecamComTermo(texto, termo) {
              const palavras = texto.split(/\s+/);
              return palavras.some(palavra => palavra.startsWith(termo));
            }

            let results = []

            newTag.forEach((tag) => {
              records.forEach((obj) => {
                contemPalavrasQueComecamComTermo(obj.body, tag)
                if (contemPalavrasQueComecamComTermo(obj.body, tag) == true && contemPalavrasQueTerminamComTermo(obj.body, tag)) {
                  results.push({ url: obj.url, categoria: category, tag: tag })
                }
              });
            });
            setFilterdData(results);
            setTotalResultado(results.length)
          }
          setIsLoading(false);
        };
      };

      requestFreestyle.onerror = function (event) {
        console.error('Error opening database:', event.target.error);
      };
      /* GET DAS INFORMAÇÕES DE PÁGINAS VIA FIREBASE */
    } else if (verificaIndexedBlog == true && categoriaPagina == 'blog') {
      let requestBlog = indexedDB.open('sherlockInfosBlog');

      requestBlog.onsuccess = function (event) {
        setIsLoading(true);

        const db = event.target.result;
        const transaction = db.transaction("blog", "readwrite");
        const objectStore = transaction.objectStore("blog");
        const getAllRequest = objectStore.getAll();

        let results = []
        let category = "blog"

        getAllRequest.onsuccess = function (event) {
          const records = event.target.result;

          if (tipoBusca === 'contem') {
            newTag.forEach((tag) => {
              records.forEach((obj) => {
                if (obj.body.includes(tag)) {
                  results.push({ url: obj.url, categoria: category, tag: tag })
                }
              });
            });
            setFilterdData(results);
            setTotalResultado(results.length)
          } else if (tipoBusca == 'terminaCom') {
            function contemPalavrasQueTerminamComTermo(texto, termo) {
              const palavras = texto.split(/\s+/);
              return palavras.some(palavra => palavra.endsWith(termo));
            }

            let results = []

            newTag.forEach((tag) => {
              records.forEach((obj) => {
                contemPalavrasQueTerminamComTermo(obj.body, tag)
                if (contemPalavrasQueTerminamComTermo(obj.body, tag) == true) {
                  results.push({ url: obj.url, categoria: category, tag: tag })
                }
              });
            });
            setFilterdData(results);
            setTotalResultado(results.length)
          } else if (tipoBusca == 'comecaCom') {
            function contemPalavrasQueComecamComTermo(texto, termo) {
              const palavras = texto.split(/\s+/);
              return palavras.some(palavra => palavra.startsWith(termo));
            }

            let results = []

            newTag.forEach((tag) => {
              records.forEach((obj) => {
                contemPalavrasQueComecamComTermo(obj.body, tag)
                if (contemPalavrasQueComecamComTermo(obj.body, tag) == true) {
                  results.push({ url: obj.url, categoria: category, tag: tag })
                }
              });
            });
            setFilterdData(results);
            setTotalResultado(results.length)
          } else {

            function contemPalavrasQueTerminamComTermo(texto, termo) {
              const palavras = texto.split(/\s+/);
              return palavras.some(palavra => palavra.endsWith(termo));
            }

            function contemPalavrasQueComecamComTermo(texto, termo) {
              const palavras = texto.split(/\s+/);
              return palavras.some(palavra => palavra.startsWith(termo));
            }

            let results = []

            newTag.forEach((tag) => {
              records.forEach((obj) => {
                contemPalavrasQueComecamComTermo(obj.body, tag)
                if (contemPalavrasQueComecamComTermo(obj.body, tag) == true && contemPalavrasQueTerminamComTermo(obj.body, tag)) {
                  results.push({ url: obj.url, categoria: category, tag: tag })
                }
              });
            });
            setFilterdData(results);
            setTotalResultado(results.length)
          }
          setIsLoading(false);
        };
      };

      requestBlog.onerror = function (event) {
        console.error('Error opening database:', event.target.error);
      };
    } else if (verificaIndexedCMS == true && categoriaPagina == 'cms') {
      let requestCMS = indexedDB.open('sherlockInfosCMS');

      requestCMS.onsuccess = function (event) {
        setIsLoading(true);

        const db = event.target.result;
        const transaction = db.transaction("cms", "readwrite");
        const objectStore = transaction.objectStore("cms");
        const getAllRequest = objectStore.getAll();

        let results = []
        let category = "CMS"

        getAllRequest.onsuccess = function (event) {
          const records = event.target.result;

          if (tipoBusca === 'contem') {
            newTag.forEach((tag) => {
              records.forEach((obj) => {
                if (obj.body.includes(tag)) {
                  results.push({ url: obj.url, categoria: category, tag: tag })
                }
              });
            });
            setFilterdData(results);
            setTotalResultado(results.length)
          } else if (tipoBusca == 'terminaCom') {
            function contemPalavrasQueTerminamComTermo(texto, termo) {
              const palavras = texto.split(/\s+/);
              return palavras.some(palavra => palavra.endsWith(termo));
            }

            let results = []

            newTag.forEach((tag) => {
              records.forEach((obj) => {
                contemPalavrasQueTerminamComTermo(obj.body, tag)
                if (contemPalavrasQueTerminamComTermo(obj.body, tag) == true) {
                  results.push({ url: obj.url, categoria: category, tag: tag })
                }
              });
            });
            setFilterdData(results);
            setTotalResultado(results.length)
          } else if (tipoBusca == 'comecaCom') {
            function contemPalavrasQueComecamComTermo(texto, termo) {
              const palavras = texto.split(/\s+/);
              return palavras.some(palavra => palavra.startsWith(termo));
            }

            let results = []

            newTag.forEach((tag) => {
              records.forEach((obj) => {
                contemPalavrasQueComecamComTermo(obj.body, tag)
                if (contemPalavrasQueComecamComTermo(obj.body, tag) == true) {
                  results.push({ url: obj.url, categoria: category, tag: tag })
                }
              });
            });
            setFilterdData(results);
            setTotalResultado(results.length)
          } else {

            function contemPalavrasQueTerminamComTermo(texto, termo) {
              const palavras = texto.split(/\s+/);
              return palavras.some(palavra => palavra.endsWith(termo));
            }

            function contemPalavrasQueComecamComTermo(texto, termo) {
              const palavras = texto.split(/\s+/);
              return palavras.some(palavra => palavra.startsWith(termo));
            }

            let results = []

            newTag.forEach((tag) => {
              records.forEach((obj) => {
                contemPalavrasQueComecamComTermo(obj.body, tag)
                if (contemPalavrasQueComecamComTermo(obj.body, tag) == true && contemPalavrasQueTerminamComTermo(obj.body, tag)) {
                  results.push({ url: obj.url, categoria: category, tag: tag })
                }
              });
            });
            setFilterdData(results);
            setTotalResultado(results.length)
          }
          setIsLoading(false);
        };
      };

      requestCMS.onerror = function (event) {
        console.error('Error opening database:', event.target.error);
      };
    } else if (verificaIndexedFreestyle == false && categoriaPagina == 'freestyle') {
      let dataGroup = [];
      let indice = 0;

      const citiesRef = collection(db, 'sherlock');

      setIsLoading(true);

      /* TRATATIVA DE COLLECTION CASO A SELEÇÃO DO USUÁRIO FOR FREESTYLE */
      if (categoriaPagina == 'freestyle') {
        let subCollection = collection(citiesRef, 'websites', 'freestyle')
        const snap = await getDocs(subCollection);
        snap.forEach((doc) => {
          dataGroup.push(doc.data());
          dataGroup[indice]["docID"] = doc.id;
          indice = indice + 1;
        });
        selectedItems = []
        selectedItemsStatus = []
        tempSelectedItemsStatus = []
        setAllData(dataGroup);
        setVariable(categoriaPagina)
        setIsLoading(false);

        let results = []
        if (tipoBusca === 'contem') {
          newTag.forEach((tag) => {
            dataGroup.forEach((obj) => {
              if (obj.body.includes(tag)) {
                results.push({ url: obj.url, categoria: 'freestyle', tag: tag })
              }
            });
          });
          setFilterdData(results);
          setTotalResultado(results.length)
        } else if (tipoBusca == 'terminaCom') {
          function contemPalavrasQueTerminamComTermo(texto, termo) {
            const palavras = texto.split(/\s+/);
            return palavras.some(palavra => palavra.endsWith(termo));
          }

          let results = []

          newTag.forEach((tag) => {
            dataGroup.forEach((obj) => {
              contemPalavrasQueTerminamComTermo(obj.body, tag)
              if (contemPalavrasQueTerminamComTermo(obj.body, tag) == true) {
                results.push({ url: obj.url, categoria: 'freestyle', tag: tag })
              }
            });
          });
          setFilterdData(results);
          setTotalResultado(results.length)
        } else if (tipoBusca == 'comecaCom') {
          function contemPalavrasQueComecamComTermo(texto, termo) {
            const palavras = texto.split(/\s+/);
            return palavras.some(palavra => palavra.startsWith(termo));
          }

          let results = []

          newTag.forEach((tag) => {
            dataGroup.forEach((obj) => {
              contemPalavrasQueComecamComTermo(obj.body, tag)
              if (contemPalavrasQueComecamComTermo(obj.body, tag) == true) {
                results.push({ url: obj.url, categoria: 'freestyle', tag: tag })
              }
            });
          });

          setFilterdData(results);
          setTotalResultado(results.length)

        } else {

          function contemPalavrasQueTerminamComTermo(texto, termo) {
            const palavras = texto.split(/\s+/);
            return palavras.some(palavra => palavra.endsWith(termo));
          }

          function contemPalavrasQueComecamComTermo(texto, termo) {
            const palavras = texto.split(/\s+/);
            return palavras.some(palavra => palavra.startsWith(termo));
          }

          let results = []

          newTag.forEach((tag) => {
            dataGroup.forEach((obj) => {
              contemPalavrasQueComecamComTermo(obj.body, tag)
              if (contemPalavrasQueComecamComTermo(obj.body, tag) == true && contemPalavrasQueTerminamComTermo(obj.body, tag)) {
                results.push({ url: obj.url, categoria: 'freestyle', tag: tag })
              }
            });
          });
          setFilterdData(results);
          setTotalResultado(results.length)
        }

        /* CONFIGURAÇÃO DO INDEXEDB PARA FREESTYLE + TRATATIVAS */
        const indexedDB =
          window.indexedDB ||
          window.mozIndexedDB ||
          window.webkitIndexedDB ||
          window.msIndexedDB ||
          window.shimIndexedDB;

        if (!indexedDB) {
          console.log("IndexedDB não encontrado para este navegador.");
        }

        const request = indexedDB.open("sherlockInfosFreestyle", 1);

        request.onerror = function (event) {
          console.error("Ocorreu um erro com o IndexedDB");
          console.error(event);
        };

        request.onupgradeneeded = function () {
          const db = request.result;
          const store = db.createObjectStore("freestyle", { keyPath: "id" });
        };

        request.onsuccess = function () {
          const db = request.result;
          const transaction = db.transaction("freestyle", "readwrite");
          const store = transaction.objectStore("freestyle");

          let increment = 1
          dataGroup.forEach(function (e) {
            store.put({ id: increment, url: e.url, body: e.body });
            increment = increment + 1;
          });
        };
        /* TRATATIVA DE COLLECTION CASO A SELEÇÃO DO USUÁRIO FOR BLOG */
      }
    } else if (verificaIndexedBlog == false && categoriaPagina == 'blog') {
      let dataGroup = [];
      let indice = 0;

      const citiesRef = collection(db, 'sherlock');

      setIsLoading(true);

      let subCollection = collection(citiesRef, 'websites', 'blog')

      const snap = await getDocs(subCollection);
      snap.forEach((doc) => {
        dataGroup.push(doc.data());
        dataGroup[indice]["docID"] = doc.id;
        indice = indice + 1;
      });
      selectedItems = []
      selectedItemsStatus = []
      tempSelectedItemsStatus = []
      setAllData(dataGroup);
      setVariable(categoriaPagina)
      setIsLoading(false);

      let results = []

      if (tipoBusca === 'contem') {
        newTag.forEach((tag) => {
          dataGroup.forEach((obj) => {
            if (obj.body.includes(tag)) {
              results.push({ url: obj.url, categoria: 'blog', tag: tag })
            }
          });
        });
        setFilterdData(results);
        setTotalResultado(results.length)
      } else if (tipoBusca == 'terminaCom') {
        function contemPalavrasQueTerminamComTermo(texto, termo) {
          const palavras = texto.split(/\s+/);
          return palavras.some(palavra => palavra.endsWith(termo));
        }

        let results = []

        newTag.forEach((tag) => {
          dataGroup.forEach((obj) => {
            contemPalavrasQueTerminamComTermo(obj.body, tag)
            if (contemPalavrasQueTerminamComTermo(obj.body, tag) == true) {
              results.push({ url: obj.url, categoria: 'blog', tag: tag })
            }
          });
        });
        setFilterdData(results);
        setTotalResultado(results.length)
      } else if (tipoBusca == 'comecaCom') {
        function contemPalavrasQueComecamComTermo(texto, termo) {
          const palavras = texto.split(/\s+/);
          return palavras.some(palavra => palavra.startsWith(termo));
        }

        let results = []

        newTag.forEach((tag) => {
          dataGroup.forEach((obj) => {
            contemPalavrasQueComecamComTermo(obj.body, tag)
            if (contemPalavrasQueComecamComTermo(obj.body, tag) == true) {
              results.push({ url: obj.url, categoria: 'blog', tag: tag })
            }
          });
        });

        setFilterdData(results);
        setTotalResultado(results.length)

      } else {

        function contemPalavrasQueTerminamComTermo(texto, termo) {
          const palavras = texto.split(/\s+/);
          return palavras.some(palavra => palavra.endsWith(termo));
        }

        function contemPalavrasQueComecamComTermo(texto, termo) {
          const palavras = texto.split(/\s+/);
          return palavras.some(palavra => palavra.startsWith(termo));
        }

        let results = []

        newTag.forEach((tag) => {
          dataGroup.forEach((obj) => {
            contemPalavrasQueComecamComTermo(obj.body, tag)
            if (contemPalavrasQueComecamComTermo(obj.body, tag) == true && contemPalavrasQueTerminamComTermo(obj.body, tag)) {
              results.push({ url: obj.url, categoria: 'blog', tag: tag })
            }
          });
        });
        setFilterdData(results);
        setTotalResultado(results.length)
      }

      /* CONFIGURAÇÃO DO INDEXEDB PARA BLOG + TRATATIVAS */
      const indexedDB =
        window.indexedDB ||
        window.mozIndexedDB ||
        window.webkitIndexedDB ||
        window.msIndexedDB ||
        window.shimIndexedDB;

      if (!indexedDB) {
        console.log("IndexedDB não encontrado para este navegador.");
      }

      const request = indexedDB.open("sherlockInfosBlog", 1);

      request.onerror = function (event) {
        console.error("Ocorreu um erro com o IndexedDB");
        console.error(event);
      };

      request.onupgradeneeded = function () {
        const db = request.result;
        const store = db.createObjectStore("blog", { keyPath: "id" });
      };

      request.onsuccess = function () {
        const db = request.result;
        const transaction = db.transaction("blog", "readwrite");
        const store = transaction.objectStore("blog");

        let increment = 1
        dataGroup.forEach(function (e) {
          store.put({ id: increment, url: e.url, body: e.body });
          increment = increment + 1;
        });
      };
    } else if (verificaIndexedCMS == false && categoriaPagina == 'cms') {
      let dataGroup = [];
      let indice = 0;

      const citiesRef = collection(db, 'sherlock');

      setIsLoading(true);

      let subCollection = collection(citiesRef, 'websites', 'cms')

      const snap = await getDocs(subCollection);
      snap.forEach((doc) => {
        dataGroup.push(doc.data());
        dataGroup[indice]["docID"] = doc.id;
        indice = indice + 1;
      });
      selectedItems = []
      selectedItemsStatus = []
      tempSelectedItemsStatus = []
      setAllData(dataGroup);
      setVariable(categoriaPagina)
      setIsLoading(false);

      let results = []

      if (tipoBusca === 'contem') {
        newTag.forEach((tag) => {
          dataGroup.forEach((obj) => {
            if (obj.body.includes(tag)) {
              results.push({ url: obj.url, categoria: 'cms', tag: tag })
            }
          });
        });
        setFilterdData(results);
        setTotalResultado(results.length)
      } else if (tipoBusca == 'terminaCom') {
        function contemPalavrasQueTerminamComTermo(texto, termo) {
          const palavras = texto.split(/\s+/);
          return palavras.some(palavra => palavra.endsWith(termo));
        }

        let results = []

        newTag.forEach((tag) => {
          dataGroup.forEach((obj) => {
            contemPalavrasQueTerminamComTermo(obj.body, tag)
            if (contemPalavrasQueTerminamComTermo(obj.body, tag) == true) {
              results.push({ url: obj.url, categoria: 'cms', tag: tag })
            }
          });
        });
        setFilterdData(results);
        setTotalResultado(results.length)
      } else if (tipoBusca == 'comecaCom') {
        function contemPalavrasQueComecamComTermo(texto, termo) {
          const palavras = texto.split(/\s+/);
          return palavras.some(palavra => palavra.startsWith(termo));
        }



        let results = []

        newTag.forEach((tag) => {
          dataGroup.forEach((obj) => {
            contemPalavrasQueComecamComTermo(obj.body, tag)
            if (contemPalavrasQueComecamComTermo(obj.body, tag) == true) {
              results.push({ url: obj.url, categoria: 'cms', tag: tag })
            }
          });
        });

        setFilterdData(results);
        setTotalResultado(results.length)

      } else {

        function contemPalavrasQueTerminamComTermo(texto, termo) {
          const palavras = texto.split(/\s+/);
          return palavras.some(palavra => palavra.endsWith(termo));
        }

        function contemPalavrasQueComecamComTermo(texto, termo) {
          const palavras = texto.split(/\s+/);
          return palavras.some(palavra => palavra.startsWith(termo));
        }

        let results = []

        newTag.forEach((tag) => {
          dataGroup.forEach((obj) => {
            contemPalavrasQueComecamComTermo(obj.body, tag)
            if (contemPalavrasQueComecamComTermo(obj.body, tag) == true && contemPalavrasQueTerminamComTermo(obj.body, tag)) {
              results.push({ url: obj.url, categoria: 'cms', tag: tag })
            }
          });
        });
        setFilterdData(results);
        setTotalResultado(results.length)
      }

      /* CONFIGURAÇÃO DO INDEXEDB PARA BLOG + TRATATIVAS */
      const indexedDB =
        window.indexedDB ||
        window.mozIndexedDB ||
        window.webkitIndexedDB ||
        window.msIndexedDB ||
        window.shimIndexedDB;

      if (!indexedDB) {
        console.log("IndexedDB não encontrado para este navegador.");
      }

      const request = indexedDB.open("sherlockInfosCMS", 1);

      request.onerror = function (event) {
        console.error("Ocorreu um erro com o IndexedDB");
        console.error(event);
      };

      request.onupgradeneeded = function () {
        const db = request.result;
        const store = db.createObjectStore("cms", { keyPath: "id" });
      };

      request.onsuccess = function () {
        const db = request.result;
        const transaction = db.transaction("cms", "readwrite");
        const store = transaction.objectStore("cms");

        let increment = 1
        dataGroup.forEach(function (e) {
          store.put({ id: increment, url: e.url, body: e.body });
          increment = increment + 1;
        });
      };
    }
    getLogInfo()
  }

  async function getURLsearch() {
    let tipoBusca = document.querySelectorAll('.selectBusca')[0].value
    let categoriaPagina = document.querySelectorAll('.selectBusca')[1].value

    let dataGroup = [];
    let indice = 0;

    const citiesRef = collection(db, 'sherlock');

    setIsLoading(true);

    /* TRATATIVA DE COLLECTION CASO A SELEÇÃO DO USUÁRIO FOR FREESTYLE */
    if (categoriaPagina == 'freestyle') {
      let subCollection = collection(citiesRef, 'websites', 'freestyle')
      const snap = await getDocs(subCollection);
      snap.forEach((doc) => {
        dataGroup.push(doc.data());
        dataGroup[indice]["docID"] = doc.id;
        indice = indice + 1;
      });
      selectedItems = []
      selectedItemsStatus = []
      tempSelectedItemsStatus = []
      setAllData(dataGroup);
      setVariable(categoriaPagina)
      setIsLoading(false);

      let results = []
      if (tipoBusca === 'contem') {
        newTag.forEach((tag) => {
          dataGroup.forEach((obj) => {
            if (obj.url.includes(tag)) {
              results.push({ url: obj.url, categoria: 'freestyle', tag: tag })
            }
          });
        });
        setFilterdData(results);
        setTotalResultado(results.length)
      } else if (tipoBusca == 'terminaCom') {
        function contemPalavrasQueTerminamComTermo(texto, termo) {
          const palavras = texto.split(/\s+/);
          return palavras.some(palavra => palavra.endsWith(termo));
        }

        let results = []

        newTag.forEach((tag) => {
          dataGroup.forEach((obj) => {
            contemPalavrasQueTerminamComTermo(obj.url, tag)
            if (contemPalavrasQueTerminamComTermo(obj.url, tag) == true) {
              results.push({ url: obj.url, categoria: 'freestyle', tag: tag })
            }
          });
        });
        setFilterdData(results);
        setTotalResultado(results.length)
      }

    } else if (categoriaPagina == 'blog') {
      let subCollection = collection(citiesRef, 'websites', 'blog')

      const snap = await getDocs(subCollection);
      snap.forEach((doc) => {
        dataGroup.push(doc.data());
        dataGroup[indice]["docID"] = doc.id;
        indice = indice + 1;
      });
      selectedItems = []
      selectedItemsStatus = []
      tempSelectedItemsStatus = []
      setAllData(dataGroup);
      setVariable(categoriaPagina)
      setIsLoading(false);

      let results = []

      if (tipoBusca === 'contem') {
        newTag.forEach((tag) => {
          dataGroup.forEach((obj) => {
            if (obj.url.includes(tag)) {
              results.push({ url: obj.url, categoria: 'blog', tag: tag })
            }
          });
        });
        setFilterdData(results);
        setTotalResultado(results.length)
      }
      /* TRATATIVA DE COLLECTION CASO A SELEÇÃO DO USUÁRIO FOR TODOS */
    } else if (categoriaPagina == 'cms') {
      let subCollection = collection(citiesRef, 'websites', 'cms')

      const snap = await getDocs(subCollection);
      snap.forEach((doc) => {
        dataGroup.push(doc.data());
        dataGroup[indice]["docID"] = doc.id;
        indice = indice + 1;
      });
      selectedItems = []
      selectedItemsStatus = []
      tempSelectedItemsStatus = []
      setAllData(dataGroup);
      setVariable(categoriaPagina)
      setIsLoading(false);

      let results = []

      if (tipoBusca === 'contem') {
        newTag.forEach((tag) => {
          dataGroup.forEach((obj) => {
            if (obj.url.includes(tag)) {
              results.push({ url: obj.url, categoria: 'cms', tag: tag })
            }
          });
        });
        setFilterdData(results);
        setTotalResultado(results.length)
      }
    }
    getLogInfo()
  }

  const handleButtonClick = () => {
    if (clickAction === 'getCollection') {
      getCollection();
    } else if (clickAction === 'getURLsearch') {
      getURLsearch();
    }
  };

  async function getLogInfo() {

    /* GET DAS INFORMAÇÕES DE LOG DA APLICAÇÃO VIA FIREBASE + COMPARAÇÃO COM DATA LOCAL */
    const citiesRef = collection(db, 'sherlock');
    let subCollection = collection(citiesRef, 'logs', 'log')

    const docQuery = query(subCollection, orderBy('data_atualizacao', 'desc'), limit(1),);
    const documents = await getDocs(docQuery);

    documents.forEach((doc) => {
      formatDate(doc.data().data_atualizacao)
      let dataAtualizacao = formatDate(doc.data().data_atualizacao)

      if (dataAtualizacao != dataAtualizacaoLocal) {
        /* DELETA O DATABASE FREESTYLE NO INDEXEDB */
        let reqsherlockInfosFreestyle = indexedDB.deleteDatabase("sherlockInfosFreestyle");
        reqsherlockInfosFreestyle.onsuccess = function () {
          console.log("Banco deletado com sucesso");
        };
        reqsherlockInfosFreestyle.onerror = function () {
          console.log("Não foi possível deletar o banco");
        };
        reqsherlockInfosFreestyle.onblocked = function () {
          console.log("Não foi possível excluir o banco de dados devido ao bloqueio da operação");
        };

        // /* DELETA O DATABASE BLOG NO INDEXEDB */
        let reqsherlockInfosBlog = indexedDB.deleteDatabase("sherlockInfosBlog");
        reqsherlockInfosBlog.onsuccess = function () {
          console.log("Banco deletado com sucesso");
        };
        reqsherlockInfosBlog.onerror = function () {
          console.log("Não foi possível deletar o banco");
        };
        reqsherlockInfosBlog.onblocked = function () {
          console.log("Não foi possível excluir o banco de dados devido ao bloqueio da operação");
        };

        // /* DELETA O DATABASE CMS NO INDEXEDB */
        let reqsherlockInfosCMS = indexedDB.deleteDatabase("sherlockInfosCMS");
        reqsherlockInfosCMS.onsuccess = function () {
          console.log("Banco deletado com sucesso");
        };
        reqsherlockInfosCMS.onerror = function () {
          console.log("Não foi possível deletar o banco");
        };
        reqsherlockInfosCMS.onblocked = function () {
          console.log("Não foi possível excluir o banco de dados devido ao bloqueio da operação");
        };

        /* SET DA NOVA DATA COMO SENDO A NOVA DATA LOCAL */
        localStorage.setItem('dataAtualizacaoLocal', dataAtualizacao);
      }
    });
  }

  /* EXECUÇÃO JÁ NO INÍCIO DA APLICAÇÃO, PARA VERIFICAR SE O USUÁRIO ESTÁ EM DIA */
  getLogInfo()

  let dataAtualizacaoLocal = localStorage.getItem('dataAtualizacaoLocal');

  return (
    <section className={styles.teste}>
      {isLoading ? <LoadingSpinner className="loader" /> : null}
      <div>
        <div><h1>Sherlock</h1></div>
        <div className={styles.painelInicial}>
          <div className={styles.tagsinput}></div>
          <div className={styles.searchButtons}>
            <button className={clickAction === 'getCollection' ? styles.painelColorRed : styles.painelColorGrey} onClick={() => { setClickAction('getCollection'), setCategorias(true) }}>Buscar por conteúdo</button>
            {/*  <button className={clickAction === 'getURLsearch' ? styles.painelColorRed : styles.painelColorGrey} onClick={() => { setClickAction('getURLsearch'), setCategorias(false) }}>Buscar por url</button> */}
          </div>
          <div className={styles.popover__wrapper}>
            <a>
              <svg className={styles.svgcategory} width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m12 3.75c-4.55635 0-8.25 3.69365-8.25 8.25 0 4.5563 3.69365 8.25 8.25 8.25 4.5563 0 8.25-3.6937 8.25-8.25 0-4.55635-3.6937-8.25-8.25-8.25zm-9.75 8.25c0-5.38478 4.36522-9.75 9.75-9.75 5.3848 0 9.75 4.36522 9.75 9.75 0 5.3848-4.3652 9.75-9.75 9.75-5.38478 0-9.75-4.3652-9.75-9.75zm9.75-.75c.4142 0 .75.3358.75.75v3.5c0 .4142-.3358.75-.75.75s-.75-.3358-.75-.75v-3.5c0-.4142.3358-.75.75-.75zm0-3.25c-.5523 0-1 .44772-1 1s.4477 1 1 1h.01c.5523 0 1-.44772 1-1s-.4477-1-1-1z" fill="#000000" fill-rule="evenodd" /></svg>
            </a>
            <div className={styles.popover__content2}>
              <p className={styles.popover__message}>Nos botões ao lado, especifique onde será realizada sua pesquisa.</p>
            </div>
          </div>
          <div className={styles.painelAtual}>
            {/* <button className={styles.atualizar}
              onClick={() => {
                verifyIndexedDB();
              }}>
              Atualizar agora
            </button> */}
            <div>
              <p id="onlineDBstatus"></p>
              <p className={styles.dataAtualizacao} id="dataAtualizacao">{dataAtualizacaoLocal}</p>
            </div>
            <Modal title="Atualização infos. Sherlock" onClose={() => setShow(false)} show={show}
              type={"gray"}
              size={"XS"}
            >
              <p>Atualizando...</p>
            </Modal>
          </div>
        </div>
        <div className={styles.painelBusca}>
          <div className={styles.textBusca}>
            <div>
              <div className={styles.palavrasChave}>
                <h2 className={styles.subtitle}>Palavras chave</h2>
                <div className={styles.popover__wrapper}>
                  <a>
                    <svg className={styles.svginfo} width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m12 3.75c-4.55635 0-8.25 3.69365-8.25 8.25 0 4.5563 3.69365 8.25 8.25 8.25 4.5563 0 8.25-3.6937 8.25-8.25 0-4.55635-3.6937-8.25-8.25-8.25zm-9.75 8.25c0-5.38478 4.36522-9.75 9.75-9.75 5.3848 0 9.75 4.36522 9.75 9.75 0 5.3848-4.3652 9.75-9.75 9.75-5.38478 0-9.75-4.3652-9.75-9.75zm9.75-.75c.4142 0 .75.3358.75.75v3.5c0 .4142-.3358.75-.75.75s-.75-.3358-.75-.75v-3.5c0-.4142.3358-.75.75-.75zm0-3.25c-.5523 0-1 .44772-1 1s.4477 1 1 1h.01c.5523 0 1-.44772 1-1s-.4477-1-1-1z" fill="#000000" fill-rule="evenodd" /></svg>
                  </a>
                  <div className={styles.popover__content}>
                    <p className={styles.popover__message}>Se você usar mais de uma tag, as páginas que contiverem mais de um dos termos aparecerão mais de uma vez na listagem de URL's.</p>
                  </div>
                </div>
              </div>
              <input
                className={styles.myTag}
                type="text"
                placeholder="Digite uma Tag"
                value={inputValue}
                onChange={handleInputChange}
                onKeyDown={handleInputKeyDown}
              />
              <div className={styles.myTags}>
                {tags.map((tag, index) => (
                  <div className={styles.tag} key={index} onClick={() => handleTagRemove(tag)}>
                    {tag}
                  </div>
                ))}
              </div>
            </div>
            <div className={styles.painelCampos}>
              <div className={styles.flexinput}>
                {categorias ?
                  <DefaultSelect
                    options={
                      [
                        {
                          label: "Contém",
                          value: "contem"
                        },
                        {
                          label: "Palavra Exata",
                          value: "palavraExata"
                        },
                        {
                          label: "Começa com",
                          value: "comecaCom"
                        },
                        {
                          label: "Termina com",
                          value: "terminaCom"
                        },
                      ]}
                    title={'Tipo de busca'}
                  />
                  :
                  <DefaultSelect
                    options={
                      [
                        {
                          label: "Contém",
                          value: "contem"
                        },
                      ]}
                    title={'Tipo de busca'}
                  />
                }
                <div className={styles.popover__wrapper}>
                  <a>
                    <svg className={styles.svginfo} width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m12 3.75c-4.55635 0-8.25 3.69365-8.25 8.25 0 4.5563 3.69365 8.25 8.25 8.25 4.5563 0 8.25-3.6937 8.25-8.25 0-4.55635-3.6937-8.25-8.25-8.25zm-9.75 8.25c0-5.38478 4.36522-9.75 9.75-9.75 5.3848 0 9.75 4.36522 9.75 9.75 0 5.3848-4.3652 9.75-9.75 9.75-5.38478 0-9.75-4.3652-9.75-9.75zm9.75-.75c.4142 0 .75.3358.75.75v3.5c0 .4142-.3358.75-.75.75s-.75-.3358-.75-.75v-3.5c0-.4142.3358-.75.75-.75zm0-3.25c-.5523 0-1 .44772-1 1s.4477 1 1 1h.01c.5523 0 1-.44772 1-1s-.4477-1-1-1z" fill="#000000" fill-rule="evenodd" /></svg>
                  </a>
                  <div className={styles.popover__content}>
                    <p className={styles.popover__message}>Especifique o <b>"Tipo de Busca"</b> que será aplicada com base nas palavras chave.</p>
                  </div>
                </div>
              </div>
              <div className={styles.flexinput}>
                <DefaultSelect
                  options={[
                    {
                      label: "Freestyle",
                      value: "freestyle"
                    },
                    {
                      label: "CMS Native",
                      value: "cms"
                    },
                    {
                      label: "Blog",
                      value: "blog"
                    },
                    // {
                    //   label: "Todos",
                    //   value: "todos"
                    // },
                  ]}
                  id={'pageCategory'}
                  title={'Categorias de páginas'}
                />
                <div className={styles.popover__wrapper}>
                  <a>
                    <svg className={styles.svgcategory} width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m12 3.75c-4.55635 0-8.25 3.69365-8.25 8.25 0 4.5563 3.69365 8.25 8.25 8.25 4.5563 0 8.25-3.6937 8.25-8.25 0-4.55635-3.6937-8.25-8.25-8.25zm-9.75 8.25c0-5.38478 4.36522-9.75 9.75-9.75 5.3848 0 9.75 4.36522 9.75 9.75 0 5.3848-4.3652 9.75-9.75 9.75-5.38478 0-9.75-4.3652-9.75-9.75zm9.75-.75c.4142 0 .75.3358.75.75v3.5c0 .4142-.3358.75-.75.75s-.75-.3358-.75-.75v-3.5c0-.4142.3358-.75.75-.75zm0-3.25c-.5523 0-1 .44772-1 1s.4477 1 1 1h.01c.5523 0 1-.44772 1-1s-.4477-1-1-1z" fill="#000000" fill-rule="evenodd" /></svg>
                  </a>
                  <div className={styles.popover__content2}>
                    <p className={styles.popover__message}>Especifique o <b>"Tipo de Categoria"</b> que será aplicada com base nas palavras chave.</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <DefaultButton
                type={"red"}
                size={"LG"}
                onClick={handleButtonClick}
                disabled={
                  inputValue.length === 0 || tags.length === 0
                }
                children={"Pesquisar"}
              />
            </div>
          </div>
        </div>
        <div className={styles.listResultado}>
          <h3>Total de Resultados: {totalResultado}</h3>
          <DownloadTableExcel
            filename="Sherlock_URLS"
            sheet="Páginas/Categorias"
            currentTableRef={tableRef.current}
          >
            <button className={styles.exportExcel}>Exportar para Excel</button>
          </DownloadTableExcel>
        </div>
        {
          filteredData.length == 0
            ? <div class="alert alert-danger" role="alert" className={styles.alertwarning}>Não foi encontrado nenhum resultado com este termo</div>
            : <></>
        }
        <div className={styles.listUrl}>
          <table className={styles.listSelecao} ref={tableRef}>
            <thead>
              <tr>
                <th>URL</th>
                <th>Tag</th>
                <th>Categoria</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((dataItem) => (
                <tr key={dataItem.id}>
                  <td className={'id-tituloNotificacao'}>
                    {dataItem.url}
                    {
                      filteredData.length > 1
                        ? <a href={dataItem.url} target="_blank">
                          <svg className={styles.svgredirect} width="20px" height="20px" viewBox="0 -0.5 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.5 6.25C12.9142 6.25 13.25 5.91421 13.25 5.5C13.25 5.08579 12.9142 4.75 12.5 4.75V6.25ZM20.25 12.5C20.25 12.0858 19.9142 11.75 19.5 11.75C19.0858 11.75 18.75 12.0858 18.75 12.5H20.25ZM19.5 6.25C19.9142 6.25 20.25 5.91421 20.25 5.5C20.25 5.08579 19.9142 4.75 19.5 4.75V6.25ZM15.412 4.75C14.9978 4.75 14.662 5.08579 14.662 5.5C14.662 5.91421 14.9978 6.25 15.412 6.25V4.75ZM20.25 5.5C20.25 5.08579 19.9142 4.75 19.5 4.75C19.0858 4.75 18.75 5.08579 18.75 5.5H20.25ZM18.75 9.641C18.75 10.0552 19.0858 10.391 19.5 10.391C19.9142 10.391 20.25 10.0552 20.25 9.641H18.75ZM20.0303 6.03033C20.3232 5.73744 20.3232 5.26256 20.0303 4.96967C19.7374 4.67678 19.2626 4.67678 18.9697 4.96967L20.0303 6.03033ZM11.9697 11.9697C11.6768 12.2626 11.6768 12.7374 11.9697 13.0303C12.2626 13.3232 12.7374 13.3232 13.0303 13.0303L11.9697 11.9697ZM12.5 4.75H9.5V6.25H12.5V4.75ZM9.5 4.75C6.87665 4.75 4.75 6.87665 4.75 9.5H6.25C6.25 7.70507 7.70507 6.25 9.5 6.25V4.75ZM4.75 9.5V15.5H6.25V9.5H4.75ZM4.75 15.5C4.75 18.1234 6.87665 20.25 9.5 20.25V18.75C7.70507 18.75 6.25 17.2949 6.25 15.5H4.75ZM9.5 20.25H15.5V18.75H9.5V20.25ZM15.5 20.25C18.1234 20.25 20.25 18.1234 20.25 15.5H18.75C18.75 17.2949 17.2949 18.75 15.5 18.75V20.25ZM20.25 15.5V12.5H18.75V15.5H20.25ZM19.5 4.75H15.412V6.25H19.5V4.75ZM18.75 5.5V9.641H20.25V5.5H18.75ZM18.9697 4.96967L11.9697 11.9697L13.0303 13.0303L20.0303 6.03033L18.9697 4.96967Z" fill="#cc0000" />
                          </svg>
                        </a>
                        : <></>
                    }
                  </td>
                  <td className={'id-tituloNotificacao'}>
                    {dataItem.tag}
                  </td>
                  <td className={'id-tituloNotificacao'}>
                    {dataItem.categoria}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  )
};

export default Sherlock;